import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Bits";

export default function AuthCallback() {
  const processed = useRef(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState({}, "", window.location.pathname);
    if (!sessionId) return navigate("/login");
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        signIn(data.token, data.user);
        navigate(data.user.profile_complete ? "/dashboard" : "/onboarding");
      })
      .catch((err) => {
        toast.error(errMsg(err));
        navigate("/login");
      });
  }, [navigate, signIn]);

  return <Loader label="Finishing sign-in…" />;
}
